<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Settings</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Site Name">
        <b-input
          type="text"
          v-model="name"
          placeholder="Enter Site Name"
          required
        ></b-input>
      </b-field>
      <b-field label="Show AgentList">
        <b-checkbox required v-model="show_agent">Show Agent List</b-checkbox>
      </b-field>
      <b-field label="WhatsApp Link">
        <b-input
          type="text"
          v-model="whatsapp"
          placeholder="ex. https://wa.me/+917575757575"
        ></b-input>
      </b-field>
      <b-field label="Alert">
        <b-input v-model="alert" type="textarea"></b-input>
      </b-field>
      <b-field label="Payment Link">
        <b-input
          type="text"
          v-model="payment"
          placeholder="ex. razorpay/paytm/upi links"
        ></b-input>
      </b-field>
      <!-- <b-field label="Primary Color">
        <b-input type="color" v-model="p_color" required></b-input>
      </b-field>
      <b-field label="Background Color">
        <b-input type="color" v-model="bg_color" required></b-input>
      </b-field> -->
      <b-field label="Header Color">
        <b-input
          type="color"
          v-model="logo_color"
          placeholder="Enter Header Color"
          required
        ></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button @click="submit()" class="button is-primary">
        Change Settings
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      alert: "",
      whatsapp: "",
      payment: "",
      show_agent: true,
      p_color: "#001b7c",
      bg_color: "#3f3f3f",
      logo_color: "",
    };
  },
  methods: {
    setup(data) {
      this.name = data.name;
      this.alert = data.alert;
      this.whatsapp = data.whatsapp;
      this.show_agent = data.show_agent;
      this.payment = data.payment;
      this.p_color = data.p_color || "#001b7c";
      this.bg_color = data.bg_color || "#3f3f3f";
      this.logo_color = data.logo_color;
    },
    submit() {
      if (!this.name) {
        return alert("Site Name can't be empty");
      }
      this.$emit("ChangeSettings", {
        name: this.name,
        alert: this.alert,
        whatsapp: this.whatsapp,
        payment: this.payment,
        show_agent: this.show_agent,
        p_color: this.p_color,
        bg_color: this.bg_color,
        logo_color: this.logo_color,
      });
      this.$parent.close();
    },
  },
  mounted() {
    this.setup(this.$store.state.info);
  },
};
</script>